/**
 * Service pour les opérations sur les catégories de formations
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const formationCategoriesService = {
  list: () => api.get(endpoints.formations.categories.list()),

  get: (id) => api.get(endpoints.formations.categories.detail(id)),

  create: (data) => api.post(endpoints.formations.categories.create(), data),

  update: (id, data) => api.put(endpoints.formations.categories.update(id), data),

  delete: (id) => api.delete(endpoints.formations.categories.delete(id))
}
